/**
 * Empty mixin for backward compatibility.
 * All translation is now handled by Vue I18n's native $t function.
 */
export default {}
